import { Link } from 'react-router-dom';
import { useMemo } from 'react';

// Utility function for scroll behavior
const scrollToTop = () => window.scrollTo(0, 0);

/**
 * A reusable bottom footer component that displays copyright information and important links.
 * This component is designed to be used across multiple pages in the application.
 * 
 * @returns The rendered bottom footer component
 */
export default function BottomFooter() {
  // Memoize year calculation to prevent unnecessary re-renders
  const currentYear = useMemo(() => new Date().getFullYear(), []);
  
  return (
    <div className="w-full bg-white dark:bg-black py-4 border-t border-gray-300 dark:border-gray-300">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex flex-wrap items-center gap-4 mb-4 md:mb-0">
            <p className="text-white">
              {currentYear} MoZo.Live. All rights reserved.
            </p>
          </div>
          <div className="flex flex-wrap gap-4 md:gap-6 justify-center md:justify-end">
            <Link to="/creators-hub?tab=legal&legal=terms" className="text-white hover:text-brand-green transition-colors" onClick={scrollToTop}>
              Terms of Use
            </Link>
            <Link to="/creators-hub?tab=legal&legal=privacy" className="text-white hover:text-brand-green transition-colors" onClick={scrollToTop}>
              Privacy Policy
            </Link>
            <Link to="/creators-hub?tab=help" className="text-white hover:text-brand-green transition-colors" onClick={scrollToTop}>
              Help Center
            </Link>

          </div>
        </div>
      </div>
    </div>
  );
}
